/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var QuoteSourceEnum;

(function (QuoteSourceEnum) {
  QuoteSourceEnum["WWG"] = "WWG";
  QuoteSourceEnum["SHIPLY"] = "Shiply";
  QuoteSourceEnum["ACTURIS"] = "Acturis";
  QuoteSourceEnum["JOVE_CMS"] = "jove_cms";
  QuoteSourceEnum["JOVE_QUOTE"] = "jove_quote";
  QuoteSourceEnum["JOVE_VALIDATION"] = "jove_validation";
  QuoteSourceEnum["JOVE_AI"] = "jove_ai";
  QuoteSourceEnum["JOVE_ASSUMPTION"] = "jove_assumption";
  QuoteSourceEnum["SWITCH_TO_JOVE"] = "switch_to_jove";
  QuoteSourceEnum["QUICK_CALCULATOR"] = "quick_calculator";
  QuoteSourceEnum["APPLICATION_FORM"] = "application_form";
})(QuoteSourceEnum || (QuoteSourceEnum = {}));